import { useQuery } from '@apollo/client';
import { GET_YARDS } from 'utils/graphQL/queries/yardService';
export function useYards({ isOpen = true, marketId = null, status = 'active', sortBy = 'nameInternal', sortOrder = 'ascend', }) {
    var _a, _b, _c;
    const { data, loading, error, refetch } = useQuery(GET_YARDS, {
        variables: {
            sortBy,
            sortOrder,
            skip: null,
            limit: null,
            yardInput: {
                id: null,
                marketId,
                nameInternal: null,
                status,
            },
        },
        skip: !isOpen,
        fetchPolicy: 'cache-first',
    });
    return {
        yards: (_b = (_a = data === null || data === void 0 ? void 0 : data.getYards) === null || _a === void 0 ? void 0 : _a.yards) !== null && _b !== void 0 ? _b : [],
        isLoading: loading,
        error: (_c = error === null || error === void 0 ? void 0 : error.message) !== null && _c !== void 0 ? _c : null,
        refetch,
    };
}
